<template>
  <b-card id="filters" class="mb-4" header-bg-variant="custom" no-body>
    <template #header>
      <h4 v-html="$t(tKey + 'header')" class="mb-1 text-white" />
    </template>
    <b-card-body>
      <b-row>
        <b-col sm="12" md="6" class="mt-3" v-if="monthPrecise">
          <FilterMonthSelect :default="monthPrecise" @transmit="updateData" />
        </b-col>
        <b-col sm="12" md="6" class="mt-3" v-if="region">
          <FilterRegion @transmit="updateData" />
        </b-col>
        <b-col sm="12" md="6" class="mt-3" v-if="year">
          <FilterYear :default="defaultValues.year" @transmit="updateData" />
        </b-col>
        <b-col sm="12" md="6" class="mt-3" v-if="period">
          <FilterPeriod @transmit="updateData" />
        </b-col>
        <b-col sm="12" md="6" class="mt-3" v-if="monthRange">
          <FilterMonthRange @transmit="updateData" />
        </b-col>
        <b-col sm="12" md="6" class="mt-3" v-if="competitors">
          <FilterCompetitor @transmit="updateData" />
        </b-col>
        <b-col sm="12" md="6" class="mt-3" v-if="markets">
          <FilterMarkets @transmit="updateData" />
        </b-col>
        <b-col sm="12" md="6" class="mt-3" v-if="comparisonYear">
          <FilterComparisonYear
            :key="this.selectedYear"
            :selectedYear="this.selectedYear"
            @transmit="updateData"
          />
        </b-col>
        <b-col sm="12" md="6" class="mt-3" v-if="weekdaysFilter">
          <FilterWeekdays @transmit="updateData" />
        </b-col>
      </b-row>
      <RefreshButton class="mt-3" @refresh="refresh" />
    </b-card-body>
    <b-card-footer class="small">
      <b-row style="width: 100%;">
        <div class="col-md-6">
          <span v-html="dataSource" />
        </div>
        <div class="col-md-6 text-right" v-if="mipFaq">
          <router-link :to="$i18nRoute({ name: 'MobilityInsightsFaq' })">
            <font-awesome-icon icon="question-circle"></font-awesome-icon> FAQ
          </router-link>
        </div>
      </b-row>
      
    </b-card-footer>
  </b-card>
</template>

<script>
import FilterPeriod from "./FilterPeriod"
import FilterYear from "./FilterYear"
import FilterRegion from "./FilterRegion"
import FilterMonthRange from "./FilterMonthRange"
import FilterMarkets from "./FilterMarkets"
import FilterComparisonYear from "./FilterComparisonYear"
import FilterCompetitor from "./FilterCompetitor"
import FilterMonthSelect from "./FilterMonthSelect.vue"
import FilterWeekdays from "./FilterWeekdays"

import RefreshButton from "./RefreshButton"
import moment from "moment"

export default {
  components: {
    FilterPeriod,
    FilterYear,
    FilterRegion,
    FilterMonthRange,
    FilterMarkets,
    FilterComparisonYear,
    FilterCompetitor,
    RefreshButton,
    FilterMonthSelect,
    FilterWeekdays
  },
  props: {
    period: { type: Boolean, default: false },
    year: { type: Boolean, default: false },
    region: { type: Boolean, default: false },
    info: { type: Object, default: null },
    monthRange: { type: Boolean, default: false },
    monthPrecise: { type: Object, default: null},
    markets: { type: Boolean, default: false },
    comparisonYear: { type: Boolean, default: false },
    competitors: { type: Boolean, default: false },
    dataSource: { type: String, required: true },
    mipFaq: { type: Boolean, default: false },
    weekdaysFilter: { type: Boolean, default: false },
    selectedYear: { type: Number, default: null },
  },
  data() {
    return {
      tKey: 'filter.',
      params: {
        monthrange: null,
        year: null,
        region: null,
        destination: null,
        platform: null,
        weekdays:null,
      },
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    updateData(value, key) {
      this.params[key] = value
      if (this.params.monthrange)
        this.selectedYear = moment(this.params.monthrange[0]).year();
    },
    refresh() {
      this.$emit("refresh", this.params)
    },
  }
}
</script>

<style lang="scss">
#filters .input-group-text {
  background: $colorbase-dark !important;
  color: white !important;
  border-radius: 5px 0 0 5px;
}
#filters select option:checked {
  background: linear-gradient($colorbase-lighter, $colorbase-dark);
  background-color: $colorbase-dark !important; /* for IE */
  color: white !important;
  font-weight: bold;
}

#filters .card-footer {
  display: flex;
  justify-content: space-between;
}

#filters label {
  font-weight: 600;
}
</style>
